import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'


export default function Main() {

  const [packages,setpackages]=useState([])
  const [allmonth,setallmonth]=useState([])
  const [month_id,setmonth_id]=useState('')

  useEffect(() => {
    getAllMonth();
  }, []);



  const getAllMonth = async ()=> {
    const data = new FormData();
    
    data.append('name',"nme");


            axios({
              method: 'post',
              url: '/api/package/all_month_type.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
               
                
            
                setallmonth(s.data)
                console.log(s.data)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };




  const getselected_pacakge = async (v)=> {
    const data = new FormData();
    
    data.append('slug',v);


            axios({
              method: 'post',
              url: '/api/package/allpackages_view.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
               
                
            
                setpackages(s.data)
                console.log("view packages list ",s.data)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };



  return (
    <>
     <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
       
       <Head />
       <div>
    

{/* 2 */}
        <div className="page-content">
         
        
    
         <div className='row' >
            <div className='col-6' style={{padding:"4px"}}>
              Select Page Packages
              </div>
              </div>
         <div className='row' >
            <div className='col-4'>
              
              <select value={month_id} onChange={(v)=>{ setmonth_id(v.target.value); }} className='form-control'>
               <option></option>

               {
                allmonth.map((v)=>(
                  <option value={v.slug}>{v.name}</option>
                ))
               }
               
              
               </select>
            </div>
            <div className='col-2'>
            <div>
            
                <button  className="btn btn-primary" onClick={()=>{
                  console.log("month_id",month_id)
                  getselected_pacakge(month_id);
                }} >
                  <i className="link-icon" data-feather="plus" /> Get Packages </button>
              </div>
            </div>
       
         </div>
          <br/>
        <div className='row'>

        

        {
          packages.map((v,i)=>(
            <div className='col-6'>
            <div className="card">
            <div className="card-body">
          

            <div className="row">
            
         


      <div className='col-1' >
{i+1}

  </div>

  

              <div className='col-2' >
               <h5 style={{color:"Indigo"}}> Title </h5>
              </div>

              <div className='col-7' >
               <h5 style={{color:"Coral"}}> {
                  v.name
                }</h5>
              </div>

              <div className='col-1' >
              <a href={"updatepackage?id="+v.id+"&m="+v.month_id}> <button className='btn btn-primary' >  Edit</button>
                </a>
              
                </div>
               

           

             
                </div>
              </div>

            
            </div>
           
            </div>

          ))
        }
    
    </div>

</div>

    </div>
     
  
       
        <Footer/>
       
      </div>
    </div>
  </>

  )
}
